<script>
	import "../shared.css";
	export let score;
	export let right = 0.45;
	$: isNegative = score.startsWith('-');
</script>

<div class="fixed-score" style="--right:{right}em">
	<img src={isNegative ? "assets/vp/vp-negative.png" : "assets/vp/vp-positive.png"} alt={score} />
	<div class="score-label font-body-std">{score}</div>
</div>

<style lang="scss">
	.fixed-score {
		position: absolute;
		width: min-content;
		height: min-content;
		top: calc(0px - var(--height) / 80.2); // -5px;
		right: var(--right);
		& > img {
			height: 1.8em;
		}
	}
	@mixin stroke($color: #000, $size: 1px) {
		text-shadow: -#{$size} -#{$size} 0 $color, 0 -#{$size} 0 $color, #{$size} -#{$size} 0 $color,
			#{$size} 0 0 $color, #{$size} #{$size} 0 $color, 0 #{$size} 0 $color,
			-#{$size} #{$size} 0 $color, -#{$size} 0 0 $color;
	}
	.score-label {
		position: absolute;
		width: 100%;
		height: 100%;
		align-items: center;
		justify-content: center;
		font-size: calc(var(--width) / 22.278); //18px;
		font-weight: 800;
		line-height: 1;
		@include stroke(#fff, 1.5px);
	}
</style>
